<template>
  <div class="container">
    <div class="tableList">
      <table v-if="region=='taskDetail'">
        <tr>
          <th rowspan="2">款式名称</th>
          <th colspan="4" style="border-bottom: solid 1px #fff;">平台等级&任务佣金</th>
          <!-- <th style="border-right: 1px solid #dfb876">款式价位</th> -->
        </tr>
        <tr>
          <th>LV1</th>
          <th>LV2</th>
          <th>LV3</th>
          <th>LV4</th>
        </tr>
        <tr v-for="(item,index) in missionInfo.models" :key="index">
          <td>{{item.name}}</td>
          <td>
            <span v-if="item.lv1Pay">￥</span>{{item.lv1Pay}}
          </td>
          <td>
            <span v-if="item.lv2Pay">￥</span>{{item.lv2Pay}}
          </td>
          <td>
            <span v-if="item.lv3Pay">￥</span>{{item.lv3Pay}}
          </td>
          <td style="border-right: 1px solid #dfb876">
            <span v-if="item.lv4Pay">￥</span>{{item.lv4Pay}}
          </td>

        </tr>
      </table>
      <p style="padding-left: 10%;" v-if="region=='taskDetail'">备注：每个等级对应的价格为该任务最终获得的佣金价，最终解释权归平台所有。</p>
      <div v-if="region!='taskDetail'" class="works-area">
        <!-- ==============重新上传弹窗==============start-->
        <div class="show-model" v-show="showFastModal" style="position: absolute;left:0;z-index:99">
          <ShowModel ref="modelFastFrom" @close="close" title="重新上传附件" :isShowModel="showFastModal">
            <div slot="shop-list" class="shop-list">
              <div class="shopList" style="text-align: center;margin: 50px 0">
                上传PDF：
                <img @click="reSelectFile" src="../../../static/image/hallNoSubmit/uploadpdf.svg" class="pdf-img" style="margin-top: 0"></img>
                <input :type="inputType" id="reFileName" @change="uploading($event,2)" style="display: none" accept=".pdf">
                <span v-show="oldFileName == null || oldFileName == ''" class="file-name" @click="reSelectFile">请上传pdf文件</span>
                <span v-show="oldFileName != null && oldFileName !== ''" class="file-name" @click="reSelectFile">{{oldFileName}}</span>
              </div>
              <div style="height: 25px;text-align: center;">
                <span style="color: red;display: block;" v-show="errorMessageShow">提示：请先上传PDF文件</span>
              </div>
              <div style="text-align: center;width: 50%;margin-left: 25%;margin-top: 40px;">
                <el-button type="info" round style="width: 40%" @click="close">取消</el-button>
                <el-button type="warning" round style="width: 40%" @click="reSubmit">提交审核</el-button>
              </div>
            </div>
          </ShowModel>
        </div>
        <!-- ==============重新上传弹窗==============end-->

        <!-- ==============上传3D效果图弹窗==============start-->
        <div class="show-model" v-show="showFast3DModal" style="position: absolute;left:0;">
          <ShowModel ref="modelFastFrom" @close="close" title="3D效果图下载地址" :isShowModel="showFast3DModal">
            <div slot="shop-list" class="shop-list" style="text-align: center;">
              <div class="works-row" style="height: 50px;line-height: 50px;">
                <span style="color: red;position: absolute;margin-left: -10px;margin-top: 4px;">*</span>
                下载地址：<el-input placeholder="请输入网盘下载地址" size="small" style="width: 50%" v-model="Downloadadd"></el-input>
              </div>
              <div class="works-row" style="height: 50px;line-height: 50px;">
                下载密码：<el-input placeholder="请输入作品网盘下载密码" size="small" style="width: 50%" v-model="subpassword"></el-input>
              </div>
              <div style="text-align: center;width: 50%;margin-left: 25%;margin-top: 40px;">
                <el-button type="info" round @click="close">取消</el-button>
                <el-button type="warning" round @click="re3DSubmit">提交审核</el-button>
              </div>
            </div>
          </ShowModel>
        </div>
        <!-- ==============上传3D效果图弹窗==============end-->



        <div v-for="(item,index) in missionInfo.worksReturnVoList" class="works-one">
          <div class="works-row">款式编号：{{item.modelCode}}</div>
          <div class="works-row">款式名称：{{item.modelName}}</div>
          <div class="works-row" v-if="missionInfo.taskStatus == '1'|| (item.worksStatus == 1 && item.worksStage == 3) || item.worksStatus == 1">
            <!-- 款式价位：￥{{item.pay}} -->
            价格: {{item.paySection}}
          </div>
          <div class="works-row" v-if="missionInfo.taskStatus == '1' || (item.worksStatus == 1 && item.worksStage == 3)">
            截稿时间：{{item.deadlineTime}}
          </div>
          <div class="works-row" v-if="missionInfo.taskStatus == '2' && (item.worksStatus != 1 && item.worksStage != 3)">
            提交审核时间：{{item.submitTime}}
          </div>
          <div class="works-row" v-if="(missionInfo.taskStatus == '2' && (item.worksStatus != 5 && item.worksStatus != 2))||missionInfo.taskStatus==3">
            审核时间：{{item.auditTime}}
          </div>

          <!--          reviewlist.worksStatus != 5 && reviewlist.worksStatus != 2-->

          <!--          ===================上传PDF相关==================start-->
          <!--          missionInfo.taskStatus==1    待提交,可上传-->
          <!--          missionInfo.taskStatus==2    待审核,可预览-->
          <!--          item.worksStatus == 1 && item.worksStage == 3    已入围，待提交-->
          <div class="works-row" v-if="missionInfo.taskStatus == '1'">
            上传PDF：
            <img @click="selectFile(index)" src="../../../static/image/hallNoSubmit/uploadpdf.svg" class="pdf-img"></img>
            <input :type="inputType" id="fileName" @change="uploading($event,1)" style="display: none" accept=".pdf">
            <span class="file-name" @click="selectFile(index)">请上传pdf文件</span>


          </div>
          <!-- 上传的 pdf名字-->
          <div v-if="missionInfo.taskStatus == '1'">
            <div style="display: flex;align-items: center;" v-for="(item2,index2) in item.pdfList">
              <p v-show="item.fileName != null && item.fileName !== ''" class="file-name2" @click="selectFile(index)">{{item2}}</p>
              <img src="../../../static/image/close.svg" alt="" style="width: 20px;" @click="deletePdf(index,index2)">
            </div>
          </div>
          <!-- 激活邮箱弹窗 -->
          <el-dialog title="" :visible.sync="isActivation" width="30%" :before-close="handleClose">
            <span v-if='!isTrue2'>您的邮箱或银行卡未认证，是否现在认证？</span>
            <p v-if="isTrue2" style="text-align: center;font-weight: bold;margin-bottom: 25px;font-size: 20px;">请填写认证信息</p>
            <p v-if="isTrue2 && status.emailStatus==0" style="display: flex;align-items: center;">
              <span style="color: #FF0000;">*</span>邮箱：<el-input v-model="missionInfo.email" placeholder="请输入邮箱" style="width: 80%;margin-left: 28px;"></el-input>
            </p>
            <div v-if="status.infoCompleteStatus==0 && isTrue2">
              <p v-if="isTrue2" style="display: flex;align-items: center;">
                 <span style="color: #FF0000;">*</span>银行卡号：<el-input v-model="missionInfo.bankNumber" placeholder="请输入银行卡号" style="width: 80%;"></el-input>
              </p>
              <p v-if="isTrue2" style="display: flex;align-items: center;">
                 <span style="color: #FF0000;">*</span>开户银行：<el-input v-model="missionInfo.bankName" placeholder="请输入开户银行" style="width: 80%;"></el-input>
              </p>
              <p v-if="isTrue2" style="display: flex;align-items: center;">
                 <span style="color: #FF0000;">*</span>开户省市：<el-input v-model="missionInfo.bankBranch" placeholder="请输入开户省市" style="width: 80%;"></el-input>
              </p>
              <p v-if="isTrue2" style="display: flex;align-items: center;">
                 <span style="color: #FF0000;">*</span>开户人姓名：<el-input v-model="missionInfo.accountName" placeholder="请输入开户人姓名" style="width: 78%;"></el-input>
              </p>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="isActivation = false">取 消</el-button>
              <el-button @click="goActive" v-if='!isTrue2'>去认证</el-button>
              <el-button @click="ConfirmActive" v-if="isTrue2">确认认证</el-button>
            </span>
          </el-dialog>

          <div class="works-row" v-if="missionInfo.taskStatus == '2'||missionInfo.taskStatus==3">
            款式附件：
            <img src="../../../static/image/hallNoSubmit/uploadpdf.svg" class="pdf-img"></img>
            <span v-show="item.pdfUrl != null && item.pdfUrl !== ''" class="file-name" @click="selectFile(index)">{{item.pdfUrl}}</span>
            <el-button type="warning" round size="mini" @click="reUploadPDF(index)" v-if="item.worksStatus == 1 && item.worksStage == 3"
              style="margin-left: 20px;position: absolute">重新上传
            </el-button>
          </div>
          <!--          ===================上传PDF相关==================end-->
          <!--       新增   显示已经提交的3d效果图地址和密码-->
          <div class="works-row" v-if="item.d3IsExist==1">下载地址：{{item.d3Url}}</div>
          <div class="works-row" v-if="item.d3IsExist==1">下载密码：{{item.d3Captcha}}</div>


          <div class="works-row" v-if="item.worksStatus == 5">超时原因：{{item.overtimeReason}}</div>

          <div class="works-row" v-if="missionInfo.taskStatus==2||missionInfo.taskStatus==3">
            投稿状态：
            <span style="color:#DFB876" v-if="item.worksStatus == 1 && item.worksStage == 2">待提交</span>
            <span style="color:#DFB876" v-if="item.worksStatus == 1 && item.worksStage == 3">已入围，待提交</span>
            <span style="color:#DFB876" v-if="item.worksStatus == 2">评审中</span>
            <span style="color:#DFB876" v-if="item.worksStatus == 3">审核通过</span>
            <span style="color:#DFB876" v-if="item.worksStatus == 4">已驳回</span>
            <span style="color:#DFB876" v-if="item.worksStatus == 5">已超时</span>
          </div>
          <div class="works-row" v-if="item.worksStatus == 4">
            驳回原因：{{item.rejectReason}}
          </div>
          <div class="works-row" v-if="item.worksStage==2">
            <el-button type="warning" round size="mini" @click="upload3D(index)" style="margin-left: 20px" :disabled="isTrue">
              上传3D效果图
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import manage from "../../api/manage";

  import ShowModel from "../../components/showModel/showModel";
  import {
    Message
  } from "element-ui";

  export default {
    name: "tableRegion",
    props: ["missionInfo", "region"],
    components: {
      ShowModel
    },
    data() {
      return {
        missionInfos: [],
        isTrue: false,
        isTrue2: false,
        isActivation: false, //激活邮箱弹窗
        inputType: 'file',
        uploadIndex: 0,
        selIndexVal: 0,
        showFastModal: false,
        oldFileName: '',
        errorMessageShow: false,
        showFast3DModal: false,
        upload3DIndex: 0,
        newFileInfo: {
          'fileName': '',
          'pdfUrl': '',
          'size': '',
          'id': 0,
        },
        Downloadadd: "",
        subpassword: "",
        canSubmit: true,
        status: {},
      };
    },
    watch: {
      missionInfo:  {
        handler:function (newVal, oldVal){
              this.getPdflist();
        },

      }
    },
    created() {

    },
    methods: {
      goActive() { //去激活
        this.isTrue2 = true
      },
      ConfirmActive() {
        // this.isActivation = false
        this.getEmail()
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      deletePdf(indexs, index2) { //删除pdf
        console.log(indexs, index2)
        let pdfList = []
        let pdfName = ''
        this.missionInfo.worksReturnVoList.forEach((item, index) => {
          if (indexs == index) {
            pdfList = item.pdfList
            pdfName = item.urlList[index2]
          }
        })
        console.log(pdfName)
        pdfList.splice(index2, 1)
        this.missionInfo.urlList.forEach((item2, index2) => {
          if (item2.pdfUrl == pdfName) {
            this.missionInfo.urlList.splice(index2, 1)
          }
        })
        console.log(this.missionInfo.urlList)
      },
      getPdflist() { //watch监测获取数据
        console.log(this.missionInfo)
        this.missionInfo.worksReturnVoList = typeof(this.missionInfo.worksReturnVoList)=="undefined"?[]:this.missionInfo.worksReturnVoList;
        this.missionInfo.worksReturnVoList.forEach((item, index) => {
          this.$set(item, 'pdfList', [])
        })
        this.$set(this.missionInfo, 'urlList', [])
        this.missionInfo.worksReturnVoList.forEach((item, index) => {
          this.$set(item, 'urlList', [])
        })

        console.log(this.missionInfo.worksReturnVoList)
      },
      async selectFile(index) {
        console.log(index)
        this.uploadIndex = index;

        const res = await this.$http.getEmailStatus()
        console.log(res)
        this.status = res.result
        if (res.result.emailStatus == 0 || res.result.infoCompleteStatus == 0) { //未激活要先激活
          this.isActivation = true
          // this.getEmail()
        } else {
          this.isActivation = false
          document.getElementById("fileName").click(index);
        }

      },
      async getEmail() { //激活邮箱
        let data = {
          id: this.missionInfo.designerId,
          name: this.missionInfo.designerName,
          email: this.missionInfo.email,
          bankNumber: this.missionInfo.bankNumber,
          bankName: this.missionInfo.bankName,
          bankBranch: this.missionInfo.bankBranch,
          accountName: this.missionInfo.accountName,
          emailStatus: this.missionInfo.emailStatus,
          infoCompleteStatus: this.missionInfo.infoCompleteStatus,
        }
        if(this.missionInfo.email!='' && this.missionInfo.bankNumber!='' && this.missionInfo.bankName!=''&& this.missionInfo.bankBranch!=''&& this.missionInfo.accountName!=''){
          const res = await this.$http.getEmail(data)
          if (res.code == 200) {
            this.isActivation = false
            this.$message.success(res.result)
          } else {
            this.isActivation = true
            this.$message.warning(res.message != "" ? res.message : '提交失败', 1500);
          }
        }else{
          this.isActivation = true
          this.$message.warning("请填写必填项")
        }

      },
      async uploading(event, type) {
        console.log(this.uploadIndex, event, type,this.missionInfo)
        let file = event.target.files[0];
        let fileName = file.name;

        let fileSize = file.size;
        if (fileName.indexOf(".pdf") == -1) {
          this.$message.error('文件格式必须为pdf！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        if (fileName.length > 50) {
          this.$message.error('文件名称过长，请求改！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        if (fileSize > 1024 * 1024 * 2) {
          this.$message.error('上传文件大小不能超过2M！', 2000)
          document.getElementById("fileName").value = ""
          return false;
        }
        this.missionInfo.worksReturnVoList.forEach((item, index) => {
          if (index == this.uploadIndex) {
            console.log(this.missionInfo)
            // this.$set(item,'pdfList',[])
            item.pdfList.push(fileName)
             console.log(item.pdfList)
          }
        })
        let formData = new FormData()
        formData.append('fileName', fileName)
        formData.append('file', file)
        let res = await manage.uploadAction('/api/common/upload', formData)
        if (res.data.code == 200) {
          this.$message.success('上传成功', 1000)
          if (document.getElementById("fileName") != null) {
            console.log(document.getElementById("fileName").value)
            document.getElementById("fileName").value = ""
          }
          if (type == 1) {
            let modelId = ''
            this.missionInfo.worksReturnVoList.forEach((item, index) => {
              if (index == this.uploadIndex) {
                modelId = item.modelId
              }
            })
            let obj = {
              'pdfUrl': res.data.message,
              'modelId': modelId,
              'fileName': fileName,
              'size': fileSize
            }
            this.missionInfo.urlList.push(obj)
            this.missionInfo.worksReturnVoList[this.uploadIndex].fileName = fileName
            this.missionInfo.worksReturnVoList[this.uploadIndex].fileSize = fileSize
            this.missionInfo.worksReturnVoList[this.uploadIndex].fileUrl = res.data.message
            this.missionInfo.worksReturnVoList.forEach((item, index) => {
              if (index == this.uploadIndex) {
                item.urlList.push(res.data.message)
              }
            })
            this.$parent.changeMissionInfo(this.missionInfo);
            console.log(this.missionInfo.worksReturnVoList)
          } else {
            this.oldFileName = fileName
            this.newFileInfo.fileName = fileName;
            this.newFileInfo.pdfUrl = res.data.message;
            this.newFileInfo.size = fileSize;
            this.newFileInfo.id = this.missionInfo.worksReturnVoList[this.selIndexVal].id;
            this.errorMessageShow = false;
          }

        } else {
          this.$message.error(res.message, 1000)
        }
      },
      reUploadPDF(index) {
        this.selIndexVal = index;
        this.showFastModal = true;
        // this.oldFileName = this.missionInfo.worksReturnVoList[index].pdfUrl
      },
      showFastModalCancel() {
        this.showFastModal = false;
        this.errorMessageShow = false;
      },
      close() {
        console.log("关闭弹框");
        this.showFastModal = false;
        this.errorMessageShow = false;
        this.showFast3DModal = false;
      },
      //入围、再次选择pdf
      reSelectFile(index) {
        this.uploadIndex = index;
        document.getElementById("reFileName").click();
      },
      //入围、再次提交审核
      async reSubmit() {
        if (this.newFileInfo.fileName && this.newFileInfo.pdfUrl && this.newFileInfo.size) {
          console.log(this.canSubmit);
          if (this.canSubmit) {
            this.canSubmit = false;
            const res = await this.$http.submitModify(this.newFileInfo)
            console.log(res)
            if (res.code == 200) {
              this.showFastModal = false;
              this.$router.go(0)
              // this.$router.push({
              //   path: "/hall/hallDetail",
              //   query: {id:this.missionInfo.id},
              // });
            } else {
              this.$message({
                message: res.message,
                type: 'warning',
                customClass: 'zZindex'
              });
            }
            setTimeout(() => {
              this.canSubmit = true
            }, 2000)
          }

        } else {
          this.errorMessageShow = true;
        }
      },
      upload3D(index) {
        this.upload3DIndex = index;
        this.showFast3DModal = true;
      },
      async re3DSubmit() {
        console.log(111)
        if (this.Downloadadd) {
          let obj = {
            'id': this.missionInfo.worksReturnVoList[this.upload3DIndex].id,
            'redenringsUrl': this.Downloadadd,
            'redenringsCaptcha': this.subpassword,
          }
          const res = await this.$http.submitModify(obj)
          console.log(res)
          if (res.code == 200) {
            this.showFast3DModal = false;
            this.isTrue = true
            this.$router.push({
              path: "/hall/hallDetail",
              query: {
                id: this.missionInfo.id
              },
            });
          }
        } else {
          this.errorMessageShow = true;
        }
      }
    },
  };
</script>


<style scoped>
  .container {
    width: 100%;
  }

  table {
    width: 80%;
    margin: 0 10%;
    border-spacing: 0px;
  }

  th {
    border-right: solid 1px #fff;
    /* border-bottom: solid 1px #fff; */
    /* width: 33.33%; */
    background: #dfb876;
    color: #ffffff;
    border-spacing: 0px;
    height: 60px;
    line-height: 60px;
  }

  th:last-of-type {
    border-right: none;
  }

  td {
    width: 20%;
    border-left: solid 1px #dfb876;
    border-bottom: solid 1px #dfb876;
    text-align: center;
    border-spacing: 0px;
    /* height: 60px; */
    line-height: 60px;
    font-size: 12px;
  }

  .works-area {
    width: 80%;
    margin-left: 10%;
    padding-bottom: 40px
  }

  .works-one {
    margin-top: 10px;
    border-bottom: 1px solid #cccccc;
    padding: 20px 10px;
  }

  .works-row {
    /* height: 30px; */
    line-height: 30px
  }

  .file-name {
    margin-left: 20px
  }

  .file-name2 {
    margin: 0;
    margin-top: 10px;
    margin-right: 10px;
    padding-left: 80px;
  }

  .pdf-img {
    margin-top: 5px;
    position: absolute;
  }

  .zZindex {
    z-index: 3000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/tableRegion/tableRegion.vue